import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Avatar, Button, Typography } from 'antd';
import { LinkOutlined } from '@ant-design/icons';

const { Text, Link } = Typography;

const getAvatarSrc = avatar => {
  if (!avatar) return null;
  return avatar.small || avatar.large || null;
};

/**
 * ProductListItem component displays individual product information in a list
 * @param {Object} props - Component props
 * @param {Object} props.product - Product data
 * @param {string} props.product.id - Product unique identifier
 * @param {string} props.product.name - Product name
 * @param {string} props.product.type - Product type
 * @param {Object} props.product.avatar - Product avatar images
 * @param {Object} props.product.data - Additional product data
 * @param {function} props.onProductOpen - Callback when product is opened
 */
const ProductListItem = ({ product, onProductOpen }) => {
  const { id, name = 'Unnamed Product', type = 'No type', avatar, data } = product;

  const avatarSrc = getAvatarSrc(avatar);

  return (
    <Row align="middle" style={{ width: '100%', padding: '16px' }}>
      <Col xs={24} sm={3} style={{ textAlign: 'center' }}>
        <Avatar size={96} style={{ margin: '1em' }} src={avatarSrc} />
      </Col>
      <Col xs={24} sm={18}>
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <Text strong>{name}</Text>
          </Col>
          <Col span={24}>
            <Text type="secondary">Type: {type}</Text>
          </Col>
          {data && (
            <>
              <Col span={24}>
                <Text type="secondary">Price: ${data.price != null ? data.price : 'No price'}</Text>
              </Col>
              <Col span={24}>
                <Text type="secondary">Labor: ${data.labor != null ? data.labor : 'No labor'}</Text>
              </Col>
              <Col span={24}>
                <Text type="secondary">URL: </Text>
                {data.url ? (
                  <Link href={data.url} target="_blank" title={data.url}>
                    {data.url}
                  </Link>
                ) : (
                  <Text type="secondary">No url</Text>
                )}
              </Col>
            </>
          )}
        </Row>
      </Col>
      <Col xs={24} sm={3} style={{ textAlign: 'center' }}>
        <Button type="primary" icon={<LinkOutlined />} onClick={() => onProductOpen(id, type)}>
          Open
        </Button>
      </Col>
    </Row>
  );
};

ProductListItem.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    type: PropTypes.string,
    avatar: PropTypes.shape({
      small: PropTypes.string,
      large: PropTypes.string
    }),
    data: PropTypes.shape({
      price: PropTypes.number,
      labor: PropTypes.number,
      url: PropTypes.string
    })
  }).isRequired,
  onProductOpen: PropTypes.func.isRequired
};

export default ProductListItem;
